import { UserRole } from "tm-shared/types";

import { isManagerRole } from "@/utils/business/isManagerRole";

export interface WorkPlanCapabilities {
    canWorkWithConnectedAgentSchedule: boolean;
    canSeeManagerEmptyState: boolean;
    canUseManagerWorkControls: boolean;
    canLoadPlansAndProgressesOnStart: boolean;
    canWorkWithSalesTasks: boolean;
    canCreateCustomTaskForAgent: boolean;
}

export const getWorkPlanCapabilities = (
    role: UserRole,
): WorkPlanCapabilities => {
    const isManager = isManagerRole(role);

    return {
        canWorkWithConnectedAgentSchedule: isManager,
        canSeeManagerEmptyState: isManager,
        canUseManagerWorkControls: isManager,
        canLoadPlansAndProgressesOnStart: role === UserRole.Ta,
        canWorkWithSalesTasks: role === UserRole.Ta || role === UserRole.Sv,
        canCreateCustomTaskForAgent: isManager,
    };
};
